import { Namespace } from './constants.js'; // stateClass({ disabled: true })
// stateClass({ disabled: false, readOnly: true })

const createStateClass = componentName => {
  const componentBaseClass = `${Namespace}-${componentName}`;
  return [stateMap => {
    let ret = [];

    for (const stateName in stateMap) {
      if (stateMap[stateName]) ret.push(`${componentBaseClass} ${componentBaseClass}--${stateName}`);
    }

    return ret.join(" ");
  }, componentBaseClass];
};

export { createStateClass };
